const { default: API } = require("../api/API");

function getBusinessTeamMembers(businessID) {
  return new Promise((resolve, reject) => {
    API.get(`personal/business/${businessID}/team-members`).then(
      resolve,
      reject
    );
  });
}

export default getBusinessTeamMembers;
